import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_vendor_settlement, requestSettlementProcess } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { SINGLE_VENDOR_SETTLEMENT } from "../../../../store/types";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { Modal } from "react-bootstrap";
import moment from "moment";

const SuperAdminRequestCheckout = (props) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [edit, setEdit] = useState(false);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [selected, setSelected] = useState(history.location?.state.data);

  let filteredData = history.location?.state.data;

  useEffect(() => {
    let total = '0.00';
    selected.forEach(data => {
      let t = data.orderPayAmount + data.orderTipAmount + data.expPayAmount + data.scanAndPayPayAmount;
      total = (parseFloat(total) + t).toFixed(2);
    });
    setTotalAmount(total)
  }, [selected])

  const onSelect = (data) => () => {
    if (selected.some(ele => ele._id === data._id)) {
      let newdata = selected.filter(ele => ele._id !== data._id);
      setSelected(newdata);
      let t = data.orderPayAmount + data.orderTipAmount + data.expPayAmount + data.scanAndPayPayAmount;
      setTotalAmount((parseFloat(totalAmount) - t).toFixed(2));
    } else {
      let newdata = [...selected, data];
      setSelected(newdata);
      let t = data.orderPayAmount + data.orderTipAmount + data.expPayAmount + data.scanAndPayPayAmount;
      setTotalAmount((parseFloat(totalAmount) + t).toFixed(2));
    }
  }

  const onSuccess = () => {
    history.push("/superadmin/initiated-settlement")
  }

  const onRequest = () => {
    let restaurantIds = selected.map(ele => ele._id);
    let formData = {
      restaurantIds: restaurantIds,
      startDate: history.location.state.startDate,
      endDate: history.location.state.endDate,
      total: parseFloat(totalAmount)
    }
    props.requestSettlementProcess(formData, onSuccess);
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 pl-5 pr-5">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="super_admin_add_vendor mb-4">
                    <h5 className="main_header_text">
                      Request Payout Check Merchant Details
                    </h5>
                    <div className="f12-400" style={{ color: "#9E9E9E" }}>
                      Please check the data before placing request
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400"
                  >
                    Report Run Date: {moment().format('Do MMM, YYYY')}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment(history.location?.state?.startDate).format('Do MMM, YYYY')} {"-"} {moment(history.location?.state?.endDate).format('Do MMM, YYYY')}
                  </span>
                </div>
              </div>

              <div className="mt-3 mb-3 d-flex justify-content-between align-items-center">
                <div>
                  {/* Earnings count */}
                  <div className="d-flex main-component-itemsforsellement align-items-center">
                    <div
                      className="mr-3 p-2"
                      style={{ background: "white", borderRadius: "50%" }}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/earnings.png")}
                        width="45px"
                      />
                    </div>
                    <div>
                      <div className="f18-700">
                        ₹{" "}
                        {totalAmount}
                      </div>
                      <div className="f14-400">Total amount</div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center">
                  <div className="mr-3">
                    <div
                      style={{ color: "#2196F3", textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => setEdit(true)}
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <TableHead />
                    </thead>
                    {loading ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {filteredData &&
                          filteredData.map((data, index) => (
                            <TableBody key={index} data={data} edit={edit} onSelect={onSelect}
                              selected={selected} />
                          ))}
                      </>
                    )}
                  </Table>
                </div>
                <div className="d-flex align-items-center pt-4 mb-4">
                  <Button
                    variant="outline-secondary"
                    className="btn-md mr-4 px-5"
                    style={{ minWidth: "170px" }}
                    onClick={() =>
                      history.push("/superadminopenitemsettlement")
                    }
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    style={{ minWidth: "170px" }}
                    className="btn-md px-5"
                    onClick={onRequest}
                    type="button"
                  >
                    Request Payout
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
SuperAdminRequestCheckout.propTypes = {
  auth: PropTypes.object.isRequired,
  requestSettlementProcess: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_vendor_settlement:
    state.superadminManageTransactions.all_vendor_settlement,
});

export default connect(mapStateToProps, {
  requestSettlementProcess,
})(SuperAdminRequestCheckout);

const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "6%" }}>
        Select <br />
        Items
      </th>
      <th style={{ width: "24%" }}>
        Restaurant <br />
        Name/ID
      </th>
      <th style={{ width: "10%" }}>
        Tip <br /> Amount
      </th>
      <th style={{ width: "10%" }}>
        Ordering <br />
        Amount
      </th>
      <th style={{ width: "10%" }}>
        Experience <br /> Amount
      </th>
      <th style={{ width: "10%" }}>
        Scan & Pay <br />
        Amount
      </th>
      <th style={{ width: "10%" }}>
        Total Payable <br /> Amount
      </th>
      <th style={{ width: "12%" }}>
        Type of <br />
        Account
      </th>
      <th style={{ width: "12%" }}>
        Account No/
        <br /> IFSC Code
      </th>
    </tr>
  );
};

const TableBody = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const redirect = (data, access) => {
    data.startDate = props.startDate;
    data.endDate = props.endDate;
    dispatch({ type: SINGLE_VENDOR_SETTLEMENT, payload: data });
    history.push({
      pathname: "/superadminpayoutdetails",
      state: { access: access, date: { startDate: props.startDate, endDate: props.endDate } },
    });
  };

  const redirectHistory = (vendorId, data) => {
    dispatch({ type: SINGLE_VENDOR_SETTLEMENT, payload: data });
    history.push(`/superadminpayouthistory/${vendorId}`);
  };

  const account = props.data.subscription?.casual_dining ? props.data.subscription.casual_dining_status.ordering.maintain_separate_bank.addedAccounts[0] : props.data.subscription.fast_food_dining_status.ordering.maintain_separate_bank.addedAccounts[0];

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr>
                <td style={{ width: "6%", textAlign: "center" }}>
                  <input type="checkbox" disabled={!props.edit} checked={props.selected.some(ele => ele._id === props.data._id)} onClick={props.onSelect(props.data)} />
                </td>

                <td style={{ width: "24%" }}>
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={props?.data?.logo_url}
                        width="45px"
                        className="rounded-circle"
                      />
                    </div>
                    <div className=" text-break ml-1">
                      <div className="f12-500">
                        {props.data.restaurant_name}
                      </div>
                      <div className="f10-500">{props.data.city}</div>
                      <div className="f10-400">{props.data._id}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.orderTipAmount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.orderPayAmount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.expPayAmount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.scanAndPayPayAmount?.toFixed(2) || 0}
                  </div>
                </td>
                {/* <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props.data &&
                    props.data.settlement &&
                    props.data.settlement[0] &&
                    props.data.settlement[0].createdAt ? (
                      <>
                        {moment(props.data.settlement[0].createdAt).format(
                          "ll"
                        )}
                        <br />
                        {moment(props.data.settlement[0].createdAt).format(
                          "LT"
                        )}
                      </>
                    ) : (
                      <> </>
                    )}
                  </div>
                </td> */}
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹{" "}
                    {Number.parseFloat(
                      props?.data?.scanAndPayPayAmount +
                      props?.data?.expPayAmount +
                      props?.data?.orderPayAmount +
                      props?.data?.orderTipAmount
                    ).toFixed(2) || 0}
                  </div>
                </td>
                {/* <td style={{ width: "10%" }}>
                  <div className="f12-500 badge badge-warning p-2">
                    Unsettled
                  </div>
                </td> */}
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    {account?.account_type || ""} <br />
                    Account
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    {account?.account_number?.replace(/\d(?=\d{3})/g, "*") || ""} <br />
                    {account?.account_ifsc?.replace(/\d(?=\d{1})/g, "*") || ""}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const InitiatePayout = (props) => {
  const [state, setState] = useState(false);
  const handleClose = (e) => setState(!state);
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="btn btn-danger btn-sm" onClick={() => setState(true)}>
        Initiate Payout
      </div>
      <Modal show={state} onHide={handleClose} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f24-700">Confirm Initiate Payout</div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="f24_700_HelveticaNeue w-75 m-auto pb-4"></div> */}
          <div className="f18-500 mt-2 mb-4">
            Are you sure you want to confirm initiate payout?
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  // onClick={(e) =>
                  //   this.props.history.push("/subscriptiondescription")
                  // }
                  onClick={handleClose}
                >
                  No
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  // style={{ width: "90%" }}
                  onClick={() => history.push("/superadmin/request-checkout")}
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
